module.exports = __webpack_public_path__ + "img/sixpackcarrier91.9cea2ddd.jpg";